export const types = {
  darkMode: "[Dark] Dark mode",
};
